import { Pack } from '../../decorators/Pack';
import { PackActivity } from '../../core';


@Pack({
    name: 'prod-build',
    clean: 'dist',
    src: 'src',
    dist: 'dist',
    handles: [
        {
            test: '*.scss',
            compiler: 'scss'
        },
        {
            test: '*.less',
            compiler: 'less'
        },
        {
            test: '*.ts',
            compiler: 'ngc'
        }
    ]
})
export class NgProdBuildActivity extends PackActivity {


                        static getClassAnnations():any  {
                            return {"name":"NgProdBuildActivity","params":{}};
                        }
                   }
